// removed by extract-text-webpack-plugin
module.exports = {"participants":"_3IQ0n","label":"_3gKKC","participant":"n8v5q","active":"_3uNOb"};


/*****************
 ** WEBPACK FOOTER
 ** ./components/Participants/styles.css
 ** module id = 344
 ** module chunks = 0
 **/